import * as yup from "yup";

export const homeFormSchema = yup.object().shape({
  status: yup.string().required("Please select status"),
});
